import { Box, styled } from '@mui/material';
import { Button } from 'components/shared/Button';
import colors from 'styles/colors';
import { withTransientMuiProps } from 'styles/common';

export const SITE_HEADER_HEIGHT = '6.2rem';

export const PageContainer = styled(Box)`
  position: relative;
  background-color: ${colors.amethystExtraLight} !important;
`;

export const Wrapper = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
`;

export const Section = styled('section')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
`;

export const ActionButton = styled(Button)`
  margin-top: 2rem !important;
`;

export const ContactLink = styled(Box)`
  margin-top: 2rem;

  a {
    font-size: 2rem;
    cursor: pointer;
  }
`;

export const Row = styled(
  Box,
  withTransientMuiProps
)<{ $marginLeft?: string; $marginTop?: string }>((props) => ({
  ...props.theme.typography.heading3,
  color: colors.amethystMain,
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',
  marginLeft: props.$marginLeft,
  marginTop: props.$marginTop,
}));
